import { all } from "redux-saga/effects";
import { sanPhamSaga } from "./sanPhamSaga";
import { sanPhamChiTietChiTietSaga } from "./sanPhamChiTietSaga";
import { categorySaga } from "./categorySaga";
import { sanPhamPhamViSaga } from "./sanPhamPhamViSaga";

export default function* sanPhamSagaWrapper() {
  yield all([
    sanPhamSaga(),
    sanPhamChiTietChiTietSaga(),
    categorySaga(),
    sanPhamPhamViSaga()
  ]);
}